var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-height-div"},[(_vm.isLoading)?_c('Spin',{attrs:{"fix":""}},[_c('Icon',{staticClass:"demo-spin-icon-load",attrs:{"type":"ios-loading","size":"18"}}),_c('div',[_vm._v("Loading")])],1):_vm._e(),_c('Table',{attrs:{"border":"","columns":_vm.columns,"data":_vm.dataArr}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }